import { gql } from '@apollo/client';

export const ALL_USERS = gql`
  query AllUsers($input: UserFilterInput!) {
    users: allUsers(input: $input) {
      aggregate {
        count
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      edges {
        node {
          createdAt
          id
          updatedAt
          email
          firstName
          lastName
          status
          roles {
            id
            name
          }
          contactNumber
          designation
          lastLogin
          serviceProvider {
            id
            name
          }
          funder {
            id
            name
          }
          institution {
            id
            name
          }
        }
      }
    }
  }
`;

export const ALL_TEAM_MEMBERS = gql`
  query AllUsers($input: UserFilterInput!) {
    users: allUsers(input: $input) {
      aggregate {
        count
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      edges {
        node {
          id
          email
          firstName
          lastName
          status
          organisations {
            id
            role {
              id
              name
            }
            practitionerType
            organisation {
              id
              isFunder
              funder {
                id
                name
              }
              isServiceProvider
              serviceProvider {
                id
                name
              }
              isInstitution
              institution {
                id
                name
              }
            }
          }
        }
      }
    }
  }
`;
